import type { SVGProps } from 'react'

const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
    <title>Close</title>
    <path
      fillRule="evenodd"
      d="m18.7 1.4-7.68 7.73-7.67-7.72c-.54-.54-1.4-.54-1.89 0-.54.54-.54 1.41 0 1.89l7.67 7.73L1.4 18.7c-.54.54-.54 1.41 0 1.89.54.54 1.41.54 1.89 0l7.73-7.68 7.68 7.68c.54.54 1.41.54 1.89 0 .49-.54.54-1.41 0-1.89l-7.68-7.68 7.68-7.67c.54-.54.54-1.4 0-1.89-.48-.54-1.35-.54-1.89-.06"
    />
  </svg>
)
export default SvgClose
